"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eBoletaCompraConverter = void 0;
const eBoletaCompraConverter = {
    toFirestore(eBoletaCompra) {
        return eBoletaCompra;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        const boleta = {
            version: data.version,
            id: data.id,
            fechaCreacion: data.fechaCreacion,
            fecha: data.fecha,
            receptor: data.receptor,
            moneda: data.moneda,
            items: data.items,
            tipo: data.tipo,
            ideBoletaAnulacion: data.ideBoletaAnulacion,
            usuarioCreador: data.usuarioCreador,
            total: data.total,
            cfeMotivoRechazoDGI: data.cfeMotivoRechazoDGI,
            comprobante: data.comprobante,
            cfeMotivoRechazoReceptor: data.cfeMotivoRechadoReceptor,
            cfeEstadoDGI: data.cfeEstadoDGI,
            cfeEstadoReceptor: data.cfeEstadoReceptor,
            cfeId: data.cfeId,
            cfeNumero: data.cfeNumero,
            cfeSerie: data.cfeSerie,
            cfeTipo: data.cfeTipo,
            adenda: data.adenda,
            cotizacion: data.cotizacion,
            local: data.local,
            comprobanteCancelante: data.comprobanteCancelante,
            comprobanteCancelado: data.comprobanteCancelado
        };
        return boleta;
    }
};
exports.eBoletaCompraConverter = eBoletaCompraConverter;
